import { render, staticRenderFns } from "./trainers.vue?vue&type=template&id=9dab8e7a"
import script from "./trainers.vue?vue&type=script&lang=js"
export * from "./trainers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports